var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttention = function SvgAttention(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.124 1.694c.823-1.425 2.93-1.425 3.752 0L19.72 15.29c.806 1.398-.23 3.126-1.876 3.126H2.155c-1.646 0-2.682-1.728-1.875-3.126L8.124 1.694zM10 2.723 2.155 16.317h15.69L10 2.723z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.924 6.877h2.152v5.244H8.924V6.877z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 14.219,
    rx: 1.076,
    ry: 1.049,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttention);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMTI0IDEuNjk0Yy44MjMtMS40MjUgMi45My0xLjQyNSAzLjc1MiAwTDE5LjcyIDE1LjI5Yy44MDYgMS4zOTgtLjIzIDMuMTI2LTEuODc2IDMuMTI2SDIuMTU1Yy0xLjY0NiAwLTIuNjgyLTEuNzI4LTEuODc1LTMuMTI2TDguMTI0IDEuNjk0ek0xMCAyLjcyMyAyLjE1NSAxNi4zMTdoMTUuNjlMMTAgMi43MjN6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNOC45MjQgNi44NzdoMi4xNTJ2NS4yNDRIOC45MjRWNi44Nzd6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48ZWxsaXBzZSBjeD0iMTAiIGN5PSIxNC4yMTkiIHJ4PSIxLjA3NiIgcnk9IjEuMDQ5IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";